var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zq-footer fx-sb-c"},_vm._l((_vm.footArr),function(item){return _c('a',{key:item.name,attrs:{"onclick":"doyoo.util.openChat('g=10065874');return false;"}},[_c('div',{staticClass:"fx-sb-c-c"},[_c('img',{staticStyle:{"width":"0.67rem"},attrs:{"src":item.img,"alt":item.name}}),_c('span',[_vm._v(_vm._s(item.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }